// The rules clipboard: a browser-local buffer holding WHICH generation was
// copied, not the rules themselves. Copy on one rules page, paste on another.
//
// Metadata only, on purpose. The paste endpoint re-reads the source generation
// server-side, so the buffer never carries a rule body that could go stale
// (source edited or deleted after the copy) or arrive rewritten. What is stored
// is only what the banner needs to say: which generation, in which project, and
// how many rules it had when copied.
//
// All storage access is guarded — private mode / disabled storage must degrade
// to "no clipboard", never to a broken rules page.

const CLIPBOARD_KEY = "rulesClipboard";

export function readClipboard() {
  try {
    const raw = window.localStorage.getItem(CLIPBOARD_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !parsed.generationId) {
      return null;
    }
    return parsed;
  } catch (_error) {
    return null;
  }
}

export function writeClipboard(entry) {
  try {
    window.localStorage.setItem(CLIPBOARD_KEY, JSON.stringify(entry));
  } catch (_error) {
    // Storage unavailable — the caller keeps its in-memory copy, so copy/paste
    // still works within the open tab; it simply won't survive a reload.
  }
  return entry;
}

export function clearClipboard() {
  try {
    window.localStorage.removeItem(CLIPBOARD_KEY);
  } catch (_error) {
    // Nothing to do: the caller drops its in-memory copy regardless.
  }
}
